import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAuthentificationFailedSmall = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 133,
	height: 91,
	viewBox: "0 0 133 91",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M0 49.2329C-1.77768e-05 57.2388 6.7075 76.3581 21.2167 84.7678C36.0316 93.3547 48.4525 86.17 65.9233 86.4533C79.1191 86.6672 87.2507 90.4652 99.7185 86.4533C117.359 80.7767 136.499 71.0444 132.453 54.1488C129.639 42.399 116.239 42.5897 107.902 33.3615C99.5855 24.1558 100.477 14.6517 90.1709 7.37749C67.8611 -8.36875 40.6525 3.42952 19.8528 20.8611C9.28408 29.7184 1.77769e-05 41.2269 0 49.2329Z",
			fill: "#FFF2F5",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 70,
			cy: 23.5,
			rx: 15,
			ry: 15.5,
			stroke: "#F29FB2",
			strokeWidth: .457112,
			strokeLinecap: "round",
			strokeDasharray: "1.83 2.74"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 25,
			cy: 24,
			rx: 25,
			ry: 24,
			transform: "matrix(-1 0 0 1 62 32)",
			stroke: "#F29FB2",
			strokeWidth: .457112,
			strokeLinecap: "round",
			strokeDasharray: "1.83 2.74"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 104,
			cy: 59.5,
			rx: 10,
			ry: 9.5,
			stroke: "#F2A2B5",
			strokeWidth: .457112,
			strokeLinecap: "round",
			strokeDasharray: "1.83 2.74"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 39.8308,
			y: 18.8608,
			width: 4.54948,
			height: .903979,
			transform: "rotate(-45 39.8308 18.8608)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 96.4398,
			y: 34.6997,
			width: 4.54948,
			height: .903979,
			transform: "rotate(-45 96.4398 34.6997)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 32.4803,
			y: 69.9121,
			width: 4.54948,
			height: .903979,
			transform: "rotate(-45 32.4803 69.9121)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 118.438,
			y: 69.0171,
			width: 4.54948,
			height: .903979,
			transform: "rotate(-45 118.438 69.0171)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 40.4346,
			y: 15.5645,
			width: 4.70488,
			height: .967645,
			transform: "rotate(45 40.4346 15.5645)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 97.0436,
			y: 31.4033,
			width: 4.70488,
			height: .967645,
			transform: "rotate(45 97.0436 31.4033)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 33.0841,
			y: 66.6162,
			width: 4.70488,
			height: .967645,
			transform: "rotate(45 33.0841 66.6162)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 119.042,
			y: 65.7207,
			width: 4.70488,
			height: .967645,
			transform: "rotate(45 119.042 65.7207)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.8896 21.9932C27.9044 22.0951 29.5068 23.7617 29.5068 25.8018L29.502 25.9971C29.4001 28.0118 27.7343 29.6139 25.6943 29.6143L25.498 29.6094C23.548 29.5107 21.9843 27.9471 21.8857 25.9971L21.8809 25.8018C21.8809 23.6959 23.5885 21.9883 25.6943 21.9883L25.8896 21.9932ZM24.4248 27.8516C24.7938 28.0806 25.2281 28.2148 25.6943 28.2148C27.0266 28.2145 28.1072 27.134 28.1074 25.8018C28.1074 25.3355 27.9732 24.9012 27.7441 24.5322L24.4248 27.8516ZM25.6943 23.3887C24.3617 23.3887 23.2813 24.4691 23.2812 25.8018C23.2813 26.2914 23.428 26.7465 23.6787 27.127L27.0195 23.7861C26.6391 23.5355 26.1839 23.3888 25.6943 23.3887Z",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73.3857 73.3154C75.4007 73.4173 77.0029 75.0838 77.0029 77.124L76.998 77.3193C76.8959 79.3339 75.2303 80.9363 73.1904 80.9365L72.9941 80.9316C71.0444 80.8328 69.4806 79.2691 69.3818 77.3193L69.377 77.124C69.377 75.0182 71.0847 73.3107 73.1904 73.3105L73.3857 73.3154ZM71.9219 79.1738C72.2907 79.4026 72.7246 79.537 73.1904 79.5371C74.5226 79.5369 75.6031 78.4562 75.6035 77.124C75.6035 76.6581 75.469 76.2243 75.2402 75.8555L71.9219 79.1738ZM73.1904 74.7109C71.8579 74.7111 70.7773 75.7914 70.7773 77.124C70.7775 77.6137 70.9249 78.0687 71.1758 78.4492L74.5166 75.1084C74.136 74.8575 73.6803 74.711 73.1904 74.7109Z",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M87.1087 19.4349C87.0535 19.214 87.2206 19 87.4483 19H90.5517C90.7794 19 90.9465 19.214 90.8913 19.4349L89.3395 25.6418C89.2512 25.9953 88.7488 25.9953 88.6605 25.6418L87.1087 19.4349Z",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 89,
			cy: 28,
			r: 1,
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_5444_1066)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M23.25 49.6562C23.25 49.6562 25.3551 52.7163 28.605 52.7163C31.8549 52.7163 33.96 49.6562 33.96 49.6562C33.96 49.6562 43.14 59.6013 43.9051 60.7488C44.6702 61.8963 37.6687 60.3663 30.5174 60.3663C23.3661 60.3663 16.7474 62.2788 18.2774 59.2188C19.8074 56.1588 23.25 49.6562 23.25 49.6562Z",
				fill: "#FFC9D6"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.7327 54.6289C20.7327 54.6289 17.068 59.6014 23.7927 58.4539C30.5174 57.3064 42.5353 58.4539 42.5353 58.4539C42.5353 58.4539 43.14 59.6014 43.9051 60.7489C44.6702 61.8965 37.6687 60.3664 30.5174 60.3664C23.3661 60.3664 16.7474 62.279 18.2774 59.2189C19.8074 56.1589 20.7327 54.6289 20.7327 54.6289Z",
			fill: "#FF92AC"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter1_d_5444_1066)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M28.6467 37.5269C32.7449 37.527 36.0676 40.8495 36.0676 44.9478C36.0675 49.0459 32.7449 52.3685 28.6467 52.3687C24.5485 52.3687 21.226 49.046 21.2258 44.9478C21.2258 40.8494 24.5484 37.5269 28.6467 37.5269Z",
				fill: "#FFCAD7",
				stroke: "#FF92AC",
				strokeWidth: 1.75
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.1882 41.2423C31.8054 41.5987 32.3198 42.1112 32.6857 42.7344C33.0516 43.3577 33.2578 44.0725 33.2861 44.8155C33.3143 45.5585 33.1637 46.3068 32.8475 46.9941C32.5314 47.6814 32.0595 48.2864 31.4737 48.7557C30.8878 49.2249 30.2061 49.5438 29.4889 49.6842C28.7717 49.8246 28.0412 49.7821 27.362 49.5605C26.6828 49.3389 26.0759 48.945 25.5951 48.4137C25.1144 47.8824 24.7745 47.2301 24.6057 46.5147C24.7394 47.0811 25.435 47.6111 25.8157 48.0317C26.2848 48.3026 26.8282 48.5299 27.3659 48.7053C27.9037 48.8808 28.7957 48.8674 29.3635 48.7562C29.9314 48.6451 30.4711 48.3926 30.9349 48.0211C31.3988 47.6495 31.8397 47.1476 32.09 46.6034C32.3403 46.0593 32.5275 45.0404 32.5052 44.4522C32.4828 43.8639 32.4816 43.1272 32.1919 42.6338C31.9022 42.1403 31.6769 41.5244 31.1882 41.2423Z",
			fill: "white",
			fillOpacity: .7
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 28.649,
			cy: 41.8384,
			rx: 1.74556,
			ry: 1.20383,
			transform: "rotate(-2.6891 28.649 41.8384)",
			fill: "white",
			fillOpacity: .7
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 26.0083,
			cy: 42.6025,
			rx: .46256,
			ry: .46256,
			transform: "rotate(-2.6891 26.0083 42.6025)",
			fill: "white",
			fillOpacity: .7
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter2_ddddd_5444_1066)",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 39.7488,
				y: 40.4438,
				width: 36.7751,
				height: 23.2264,
				rx: 2.8,
				transform: "rotate(5.81663 39.7488 40.4438)",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.5635 42.2629C39.6658 41.2583 40.5632 40.5268 41.5678 40.6292L74.5155 43.9855C75.5202 44.0879 76.2516 44.9852 76.1493 45.9899L75.7951 49.4661L39.2093 45.7392L39.5635 42.2629Z",
			fill: "#FFCAD7"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 57.591,
			y1: 58.2711,
			x2: 70.6685,
			y2: 59.6033,
			stroke: "#EF476F",
			strokeWidth: 1.37134,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 57.967,
			y1: 54.5807,
			x2: 71.0444,
			y2: 55.9129,
			stroke: "#EF476F",
			strokeWidth: 1.37134,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 58.3429,
			y1: 50.8898,
			x2: 71.4204,
			y2: 52.222,
			stroke: "#EF476F",
			strokeWidth: 1.37134,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 57.2149,
			y1: 61.9621,
			x2: 67.8854,
			y2: 63.0491,
			stroke: "#EF476F",
			strokeWidth: 1.37134,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 42.0826,
			y1: 43.3966,
			x2: 51.3089,
			y2: 44.3365,
			stroke: "white",
			strokeWidth: 1.37134,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 41.1615,
			y: 48.5117,
			width: 13.0648,
			height: 13.0648,
			rx: 1.05,
			transform: "rotate(5.81663 41.1615 48.5117)",
			fill: "#FFCAD7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.5042 59.4474C48.2302 58.8065 47.85 58.3364 47.9431 57.4221C47.999 56.8734 48.4695 56.562 48.6655 56.1069C48.8615 55.6517 49.0038 55.1037 49.1163 54.7059C49.2287 54.3082 49.2729 54.1544 49.3556 53.7269C49.4578 53.1931 49.2553 51.7678 47.4152 51.5803C45.5757 51.3929 45.0888 52.7481 45.0823 53.2916C45.0771 53.727 45.0896 53.8866 45.1194 54.2988C45.1491 54.711 45.1772 55.2764 45.2773 55.7617C45.3773 56.2471 45.776 56.6469 45.7201 57.1956C45.627 58.1099 45.1598 58.4938 43.7828 58.8646C42.4008 59.2361 41.4863 59.6481 41.4503 60.0013L41.2817 61.6561L51.391 62.6859L51.5595 61.0311C51.5955 60.6784 50.7823 60.0905 49.5042 59.4474Z",
			fill: "#FF92AC"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter3_dddd_5444_1066)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 49.7976,
				y: 69.3276,
				width: 49.7942,
				height: 9.89407,
				transform: "rotate(-45 49.7976 69.3276)",
				fill: "#EF476F"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 56.4065,
				y: 33.2383,
				width: 51.495,
				height: 10.5909,
				transform: "rotate(45 56.4065 33.2383)",
				fill: "#EF476F"
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_d_5444_1066",
				x: 15.9552,
				y: 49.6562,
				width: 30.1073,
				height: 17.8195,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 4.2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.05 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 1 0 0 0 0 0.791667 0 0 0 0 0.84127 0 0 0 0.3 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_5444_1066"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_5444_1066",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_d_5444_1066",
				x: 19.9308,
				y: 36.6519,
				width: 17.4313,
				height: 17.4313,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: .42 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .21 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.937255 0 0 0 0 0.278431 0 0 0 0 0.435294 0 0 0 0.5 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_5444_1066"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_5444_1066",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_ddddd_5444_1066",
				x: 31.0141,
				y: 40.0129,
				width: 46.8014,
				height: 42.0454,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: .35 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .525 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.960784 0 0 0 0 0.8 0 0 0 0 0.839216 0 0 0 0.29 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_5444_1066"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -.35,
						dy: 1.75
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.05 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.960784 0 0 0 0 0.8 0 0 0 0 0.839216 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_5444_1066",
						result: "effect2_dropShadow_5444_1066"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -1.05,
						dy: 4.2
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.225 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.960784 0 0 0 0 0.8 0 0 0 0 0.839216 0 0 0 0.15 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_dropShadow_5444_1066",
						result: "effect3_dropShadow_5444_1066"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -2.1,
						dy: 7.35
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.575 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.960784 0 0 0 0 0.8 0 0 0 0 0.839216 0 0 0 0.04 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect3_dropShadow_5444_1066",
						result: "effect4_dropShadow_5444_1066"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -3.15,
						dy: 11.55
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.75 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.960784 0 0 0 0 0.8 0 0 0 0 0.839216 0 0 0 0.01 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect4_dropShadow_5444_1066",
						result: "effect5_dropShadow_5444_1066"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect5_dropShadow_5444_1066",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter3_dddd_5444_1066",
				x: 45.4176,
				y: 32.5383,
				width: 50.9014,
				height: 57.2014,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: .7 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .7 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.745098 0 0 0 0 0.152941 0 0 0 0 0.290196 0 0 0 0.18 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_5444_1066"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2.1 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.05 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.745098 0 0 0 0 0.152941 0 0 0 0 0.290196 0 0 0 0.16 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_5444_1066",
						result: "effect2_dropShadow_5444_1066"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 5.25 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.575 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.745098 0 0 0 0 0.152941 0 0 0 0 0.290196 0 0 0 0.09 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_dropShadow_5444_1066",
						result: "effect3_dropShadow_5444_1066"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 9.1 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.75 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.745098 0 0 0 0 0.152941 0 0 0 0 0.290196 0 0 0 0.03 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect3_dropShadow_5444_1066",
						result: "effect4_dropShadow_5444_1066"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect4_dropShadow_5444_1066",
						result: "shape"
					})
				]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgAuthentificationFailedSmall);
export { ForwardRef as ReactComponent };
